var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getXSRF } from "../src/Services/Shared/FetchService";
export default class EarlyAlertReasonService {
    static fetchReasons(sort = "name", order = "asc") {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/earlyAlertReason/list?format=json&sort=${sort}&order=${order}`, {
                credentials: "include",
            });
            const singleResponse = yield response.json();
            return singleResponse;
        });
    }
    static fetchReason(id) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/earlyAlertReason/show/${id}?format=json`, {
                credentials: "include",
            });
            const singleResponse = yield response.json();
            return singleResponse;
        });
    }
    static saveReason(reason) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield fetch(`/aviso/earlyAlertReason/saveJson/${reason.id}`, {
                method: "POST",
                credentials: "include",
                headers: {
                    Accept: "applicaton/json",
                    "Content-Type": "application/json",
                    "X-XSRF-TOKEN": getXSRF(),
                },
                body: JSON.stringify(reason),
            });
            const singleResponse = yield response.json();
            return singleResponse;
        });
    }
}
